"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getPromoCategory = function getPromoCategory(_ref) {
  var _global$__appConfig__;
  var language = _ref.language,
    ids = _ref.ids;
  if (!global.__appConfig__.promoCategoryPerCountry || !ids) {
    return;
  }
  return ids === null || ids === void 0 ? void 0 : ids.includes((_global$__appConfig__ = global.__appConfig__.promoCategoryPerCountry[language]) === null || _global$__appConfig__ === void 0 ? void 0 : _global$__appConfig__.category);
};
var _default = getPromoCategory;
exports["default"] = _default;